module.exports = __webpack_public_path__ + "static/media/showIcon.d3e72f65.svg";